import { useMemo } from 'react';

import AgentIcon1 from '@/assets/agent-icon-1.png';
import AgentIcon2 from '@/assets/agent-icon-2.png';
import AgentIcon3 from '@/assets/agent-icon-3.png';
import AgentIcon4 from '@/assets/agent-icon-4.png';
import AgentIcon5 from '@/assets/agent-icon-5.png';
import AgentIcon6 from '@/assets/agent-icon-6.png';
import AgentIcon7 from '@/assets/agent-icon-7.png';
import AgentIcon8 from '@/assets/agent-icon-8.png';
import AgentIcon9 from '@/assets/agent-icon-9.png';
import AgentIcon10 from '@/assets/agent-icon-10.png';
import AgentIcon11 from '@/assets/agent-icon-11.png';
import AgentIcon12 from '@/assets/agent-icon-12.png';

export type UseAgentIconProps = {
  agentId?: string | null;
  className?: string;
};

export const useAgentIcon = ({ agentId, className }: UseAgentIconProps) => {
  const icons = useMemo(
    () => [
      AgentIcon1,
      AgentIcon2,
      AgentIcon3,
      AgentIcon4,
      AgentIcon5,
      AgentIcon6,
      AgentIcon7,
      AgentIcon8,
      AgentIcon9,
      AgentIcon10,
      AgentIcon11,
      AgentIcon12,
    ],
    []
  );

  return useMemo(() => {
    const sum = [...(agentId ?? '')].reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return <img className={className} src={icons[sum % icons.length]} />;
  }, [agentId, className, icons]);
};
